import officeApiGetSupportedRequirementSets from './async/infrastructure/office-api-get-supported-requirement-sets'

export function officePlatform(): string {
  return Office.context.mailbox.diagnostics.hostName || ''
}

export function officeHostVersion(): string {
  return Office.context.mailbox.diagnostics.hostVersion || ''
}

export function officeOWAView(): string {
  return Office.context.mailbox.diagnostics.OWAView || ''
}

export function officePlatformIsMobile(): boolean {
  const platform = officePlatform()
  return platform === 'OutlookIOS' || platform === 'OutlookAndroid'
}

export function officeOutlookClientVersion(): string {
  const hostName = officePlatform()
  const hostVersion = officeHostVersion()

  const getVersionParts = (version: string): { major: string; build: string } => {
    const parts = version.split('.')
    return {
      major: parts[0] || '',
      build: parts.length > 2 ? `${parts[2]}.${parts[3] || '0'}` : '',
    }
  }

  const versionParts = getVersionParts(hostVersion)

  if (hostName === 'Outlook') {
    if (versionParts.major === '15') {
      return 'Outlook 2013'
    } else if (versionParts.major === '16') {
      const buildNumber = parseFloat(versionParts.build)

      // Outlook 2016: Build numbers typically range from 16.0.4229 to 16.0.7571
      if (buildNumber >= 4229 && buildNumber <= 7571) {
        return `Outlook 2016`
      }
      // Outlook 2019: Build numbers typically start around 16.0.10325
      else if (buildNumber >= 10325 && buildNumber < 14000) {
        return `Outlook 2019`
      }
      // Outlook 2021: Build numbers typically start around 16.0.14326
      else if (buildNumber >= 14326 && buildNumber < 16000) {
        return `Outlook 2021`
      }
      // Microsoft 365: Build numbers typically higher and frequently updated
      else if (buildNumber >= 16000) {
        return `Microsoft 365 Outlook`
      }
      return `Outlook Desktop (Version: ${hostVersion})`
    }
  } else if (hostName === 'OutlookWebApp') {
    return `Outlook Web App`
  } else if (hostName === 'newOutlookWindows') {
    return `New Outlook for Windows (Version: ${hostVersion})`
  } else if (hostName === 'OutlookIOS') {
    return `Outlook on iOS (Version: ${hostVersion})`
  } else if (hostName === 'OutlookAndroid') {
    return `Outlook on Android (Version: ${hostVersion})`
  }
  return `Unknown Outlook Client (Host: ${hostName}, Version: ${hostVersion})`
}

export function officeHighestSupportedRequirementSet(): string {
  const supportedSets = officeApiGetSupportedRequirementSets()

  if (supportedSets.length === 0) {
    return '1.1'
  }

  return supportedSets[supportedSets.length - 1]
}

const exportFunctions = {
  name: officePlatform,
  version: officeHostVersion,
  owaView: officeOWAView,
  isMobile: officePlatformIsMobile,
  outlookClientVersion: officeOutlookClientVersion,
  highestSupportedRequirementSet: officeHighestSupportedRequirementSet,
}

export default exportFunctions
